import { Attribute } from './Attribute'

export default Attribute
